// src/redux/appConfigReducer.ts
const initialState = {
    config: null,
  };
  
  // Action types
  const SET_APP_CONFIG = 'SET_APP_CONFIG';
  
  // Reducer
  export const appConfigReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case SET_APP_CONFIG:
        return { ...state, config: action.payload };
      default:
        return state;
    }
  };
  
  // Action creator
  export const setAppConfig = (config: any) => ({
    type: SET_APP_CONFIG,
    payload: config,
  });
  